import React from 'react';
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import PolLinkButton from "v4/components/ui/PolLinkButton/PolLinkButton";
import {routesBase} from "v4/data/appRoutes";

export default function CompletedImport() {
    const {t} = usePolTranslation();

    return (
        <AdminCard title={t('import_completed')}>
            <p className="mb-3">{t('import_completed_successfully')}</p>

            <PolLinkButton to={routesBase.adminDataImport}>
                {t('return')}
            </PolLinkButton>
        </AdminCard>
    )
}
